"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/typeof.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != (0, _typeof2.default)(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } /** When your routing table is too long, you can split it into small modules **/
var schoolRouter = {
  path: '/publicAdmin',
  component: _layout.default,
  meta: {
    title: "行政监管部门",
    icon: "nested"
  },
  redirect: 'publicAdmin-list',
  children: [{
    path: 'publicAdmin-list',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/publicAdmin/index.vue'));
      });
    },
    name: 'publicAdminList',
    meta: {
      title: '监管人员列表',
      icon: 'dashboard'
    }
  }, {
    path: 'publicAdmin-add',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/publicAdmin/publicAdminAdd.vue'));
      });
    },
    name: 'publicAdminAdd',
    meta: {
      title: '新增监管人员',
      icon: 'dashboard'
    }
  }, {
    path: 'publicAdmin-edit',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/publicAdmin/publicAdminEdit.vue'));
      });
    },
    name: 'publicAdminEdit',
    meta: {
      title: '编辑监管人员',
      icon: 'dashboard'
    }
  }]
};
var _default = exports.default = schoolRouter;